<template>
  <v-main class="fullwidth fullheight bg_card" :class="$mq">
    <!-- PC 웹 & 모바일 -->
    <v-card
      flat
      tile
      class="mx-auto"
      min-width="320"
      :max-width="$store.state.web_max_width"
      color="transparent"
    >
      <v-row justify="center" class="title_root">
        <v-col cols="12" class="title_root_text title_root_text_another_color">
          {{ $ml.get("main_button_01") }}
        </v-col>
        <div class="title_root_text_line title_root_text_line_new_color"></div>
        <v-btn
          elevation="0"
          class="title_root_back"
          icon
          v-on:click="$router.go(-1)"
        >
        </v-btn>
      </v-row>

      <v-row justify="center" class="main_root">
        <v-card
          :class="$mq == 'sm' ? 'rounded-xl' : 'rounded-b-xl'"
          color="transparent"
          background-color="transparent"
          box-shadow="none"
          width="100%"
        >
          <!-- <v-row justify="center" class="main_title_1">
            <v-btn
              elevation="0"
              class="main_root_back"
              icon
              v-on:click="$router.go(-1)"
            >
            </v-btn>
            <v-col
              v-if="$mq != 'sm'"
              cols="12"
              class="main_title_1_text font_black"
            >
              <span>{{ $ml.get("info_title_01") }}</span>
              <img
                class="img_text"
                aspect-ratio="1"
                src="@/assets/ci_x_header.png"
              />

              <span>{{ $ml.get("info_title_02") }}</span>
            </v-col>
            <v-col
              v-else
              cols="12"
              class="d-flex flex-column align-center main_title_1_text"
            >
              <span>{{ $ml.get("main_button_01") }}</span>
              <div class="title_root_text_line_m"></div>
            </v-col>
          </v-row> -->
          <!-- <v-row
            v-if="$mq == 'sm'"
            justify="center"
            class="main_title_1 sub info_title_sub"
          >
            <v-col cols="12" class="main_title_1_text">
              <span>{{ $ml.get("info_title_01") }}</span>
              <img
                class="img_text"
                aspect-ratio="1"
                src="@/assets/m_logo_b.png"
              />
              <span>{{ $ml.get("info_title_02") }}</span>
            </v-col>
          </v-row> -->
          <v-card
            elevation="0"
            line-height="30px"
            class="d-flex align-center justify-center rounded-0 rounded-b-xl pa-0 content"
          >

            안녕하세요. 상주시정신건강복지센터입니다. <span>숨SU:M</span>은 상주시민이라면 누구나, 언제 어디서든 마음건강을 챙길 수 있는 비대면 정신건강 플랫폼입니다.<br/><br/>

            <span>숨SU:M</span>에서는 우울, 불안, 스트레스 등 <span>정신건강 자가검진</span>은 물론, <span>쉼</span>이 필요한 순간에 함께할 <span>힐링콘텐츠</span>, 그리고 <span>감각</span>을 통해 나를 돌아보는 <span>오감훈련챌린지</span>를 제공합니다.<br/><br/>

            <span>오감훈련챌린지</span>는 ‘보고, 듣고, 맛보고, 만지고, 느끼는’ 다섯 가지 감각에 집중해 주어진 주제에 따라 나의 감정을 기록하는 마음돌봄 프로그램입니다. 성실히 참여해주신 분들께는 <span>소정의 선물</span>도 드리고 있습니다.<br/><br/>

            또한, 플랫폼 이용 후 느낀 점을 자유롭게 나눌 수 있는 공간도 마련되어 있습니다.<br/><br/>

            지친 마음을 잠시 내려놓고, 편안하게 숨 고를 수 있는 곳. <span>숨SU:M</span>이 상주시민의 일상에 작은 쉼이 되길 바랍니다.

            <!-- <v-img
              :src="info_img"
              style="z-index: 3;"
              class="d-flex align-center justify-center rounded-0 rounded-b-xl pa-0 content"
              contain
            ></v-img> -->
          </v-card>
        </v-card>
      </v-row>
    </v-card>
  </v-main>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  computed: {
    title() {
      return this.$mq == "sm"
        ? this.$ml.get("main_button_01")
        : this.$ml.get("info_title");
    },
    content() {
      return this.$mq == "sm"
        ? this.$ml.get("info_content_m")
        : this.$ml.get("info_content");
    },
    info_img() {
      return this.$mq == "sm"
        ? require("@/assets/info_m.png")
        : require("@/assets/info.png");
    }
  },
  methods: {},
  created() {},
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/common";

.bg_card {
  background-image: url("../assets/bg_info.png");
}

.img_text {
  width: 60px;
  margin: 0px 0px -8px 2px;
}

.content {
  text-align: left;
  font: normal normal normal 22px/30px Noto;
  letter-spacing: 0px;
  color: $ft-color-title;
  padding: 40px !important;
  display: block !important;
}

.content span { font-size: 26px; font-weight:bold; }

.info_title_sub {
  background-color: $bg-color-Info-title-m-sub !important;
}

.title_root_text_another_color {
  color: $ft-color-title-root-color !important;
}

.title_root_text_line_new_color {
  border-top: solid 6px $ft-color-title-white;
}

/* mobile */
.sm.bg_card {
  background-image: url("../assets/bg_info_m.png");

  .main_title_1_text {
    position: relative;
  }

  .title_root_text_line_m {
    position: absolute;
    bottom: 0px;
    border-top: solid 3px $ft-color-title-white;
    height: 3px;
    width: 5vw;
  }

  .img_text {
    width: 12vw;
    margin: 0px 0px -1.2vw 2px;
  }

  .content {
    font: normal normal normal 6vw/8vw Noto;
  }
}
</style>
